import { useEffect, useRef } from 'react';
import { Mic } from 'lucide-react';
import { TTSPlayer } from '../ai/TTSPlayer';

const Bubble = ({ turn, candidateName, api, autoPlay, index }) => {
    const isRecruiter = turn.role === 'recruiter';
    return (
        <div className={`flex gap-3 animate-fade-in ${isRecruiter ? 'flex-row-reverse' : ''}`} data-testid={`eeoc-turn-${index}`}>
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
                isRecruiter ? 'bg-sky-600 text-white' : 'bg-muted text-foreground'
            }`}>
                {isRecruiter ? <Mic className="h-4 w-4" /> : candidateName.charAt(0)}
            </div>
            <div className={`max-w-[80%] space-y-1 ${isRecruiter ? 'text-right' : ''}`}>
                <p className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
                    {isRecruiter ? 'You (spoken)' : candidateName}
                </p>
                <div className={`inline-block rounded-2xl px-4 py-2.5 text-left text-sm leading-relaxed ${
                    isRecruiter ? 'rounded-tr-sm bg-sky-600 text-white' : 'rounded-tl-sm border bg-card'
                }`}>
                    {turn.text}
                </div>
                {!isRecruiter && api && (
                    <div><TTSPlayer text={turn.text} api={api} autoPlay={autoPlay} className="h-7 px-2 text-xs" /></div>
                )}
            </div>
        </div>
    );
};

export const ConversationPanel = ({ turns, candidateName, api, autoPlayIndex }) => {
    const endRef = useRef(null);
    useEffect(() => {
        endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, [turns.length]);

    return (
        <div className="max-h-[420px] space-y-4 overflow-y-auto pr-1" data-testid="eeoc-conversation">
            {turns.map((turn, i) => (
                <Bubble key={`${i}-${turn.timestamp}`} turn={turn} index={i} candidateName={candidateName} api={api} autoPlay={i === autoPlayIndex} />
            ))}
            <div ref={endRef} />
        </div>
    );
};
